export default __webpack_public_path__ + "static/media/CardPan.6fdd157c.svg";